import { useState } from 'react';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
const Tab6 = ({ customerName,
  setDisable, disable,
  setDelivery, delivery,
  setFrozen, frozen,
  setSalerOrder, salesorder
}) => {
  return (
    <div>
        <div className="px-2 py-3" style={{ background: 'white' }}>
          <div style={{ display: 'flex' }} >
            <div className="col-md-12 px-2">
              <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <div style={{ flex: 1 }}>
                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ height: '19px' }}></label>
                     <Checkbox
      id="AllowSalesInvoiceWithoutSalesOrder"
      label="Allow Sales Invoice Without Sales Order"
      value={salesorder===1 || false}   
    disabled={true}
      
    />
                   
  
                  </div>
  
                  <div style={{ flex: 1 }}>
                    <label style={{ height: '19px' }}></label>
                   <Checkbox
      id=" IsFrozen"
      label="Is Frozen"
       value={frozen===1 || false}   
    disabled={true}
     
    />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '15px' }}>
  
                  <div style={{ flex: 1 }}>
                    <label style={{ height: '19px' }}></label>
                     <Checkbox
      id="AllowSalesInvoiceWithoutDeliveryNote"
      label="Allow Sales Invoice Without Delivery Note"
       value={delivery===1 || false}   
    disabled={true}
     
    />
  
  
  
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ height: '19px' }}></label>
                     <Checkbox
      id="Disabled"
      label="Disabled"
       value={disable===1 || false}   
    disabled={true}
    />
                  </div>
                </div>
  
  
              </div>
            </div>
  
            
          </div>
          <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
             <ActivityCard doctype="Customer" docname={customerName} />
            </div>
          </div>
        </div>
        </div>
  
      </div>
  );
};

export default Tab6;
